import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { usePrivileges } from "../contexts/PrivilegesContext.js";
import { useUserModel } from "../contexts/UserContext.js";
/**
 * This hook provides the user model with its privileges and access.
 * @returns {UserModel}
 */ export var useUser = function() {
    var user = useUserModel();
    var ref = usePrivileges(), privileges = ref.privileges, access = ref.access;
    return _object_spread_props(_object_spread({}, user), {
        privileges: privileges,
        access: access
    });
};

//# sourceMappingURL=useUser.js.map